module.exports = __webpack_public_path__ + "static/media/Motorola Moto 360 Men Black + Black Open.58a88e2e.png";